export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/cadastro',
  ARENAS: '/arenas',
  PROFILE: '/perfil',
  MY_AGENDA: '/agenda',
  BOOKING: '/reservar',
  CHECKOUT: '/reservar/checkout',
  CLASSES: '/aulas',
  TOURNAMENTS: '/torneios',
  TOURNAMENT_DETAIL: '/torneios/:tournamentId',
  MURAL: '/mural',
  ARENA_ONBOARDING: '/arena/onboarding',
  ARENA_DASHBOARD: '/arena/dashboard',
  ARENA_RESERVATIONS: '/arena/reservas',
  ARENA_CLASSES: '/arena/aulas-turmas',
  ARENA_TOURNAMENTS: '/arena/torneios',
  ARENA_MURAL: '/arena/mural',
  ARENA_SUBSCRIPTIONS: '/arena/assinaturas',
  ARENA_SETTINGS: '/arena/quadras-equipe',
  ARENA_REPORTS: '/arena/relatorios',
  ADMIN_DASHBOARD: '/admin',
  INSTRUCTOR_CLASSES: '/instrutor/turmas',
  RECEPCAO_RESERVATIONS: '/recepcao/reservas',
} as const;

/** Cadastro já com o perfil "Dono de arena" selecionado — porta de entrada da demonstração. */
export const ARENA_OWNER_SIGNUP = '/cadastro?perfil=arena';
/** Mesmo cadastro, mas preenchido sozinho (simulação automática até o painel da arena). */
export const ARENA_OWNER_SIGNUP_AUTO = '/cadastro?perfil=arena&auto=1';

export function tournamentDetailPath(tournamentId: string) {
  return `/torneios/${tournamentId}`;
}
